import { Component } from '@angular/core';

@Component({
    selector: 'instant-checkup',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class InstantCheckupComponent {}
